import React, { useEffect, useState } from 'react';
import ChangePayoutIntervalModal from '../BankAccountManagerInsights/components/ChangePayoutIntervalModal';
import { StripeEnv } from '../../util/enums';
import { BankAccountRadioProps } from '../BankAccountManager/utils';
import { FinancialAccountNode } from '../../services/orgs/interfaces';
import { setStripeConnectAccountPayoutFrequency } from '../../services/vault/payout';
import { getStripeConnectAccountBankAccounts } from '../../services/vault/bankAccount';
import { BankAccount, StripeConnectAccount } from '../BankAccountManager/props';

export default function PayoutInterval({
  frequencyModalIsOpen,
  setFrequencyModalIsOpen,
  stripeEnv = StripeEnv.RAISE,
  selectedBankAccountOption,
  payableFinancialAccount,
  financialAccount,
  setBankAccounts,
  setPayableBankAccounts,
  stripeConnectAccount,
  payableStripeConnectAccount,
  onIntervalUpdate,
  setIsLoading,
  campaignInterval,
}: {
  frequencyModalIsOpen: boolean;
  setFrequencyModalIsOpen: (isOpen: boolean) => void;
  stripeEnv?: StripeEnv;
  selectedBankAccountOption?: BankAccountRadioProps;
  payableFinancialAccount?: FinancialAccountNode;
  financialAccount?: FinancialAccountNode;
  setBankAccounts: (accounts: BankAccount[]) => void;
  setPayableBankAccounts: (accounts: BankAccount[]) => void;
  stripeConnectAccount?: StripeConnectAccount;
  payableStripeConnectAccount?: StripeConnectAccount;
  onIntervalUpdate: (interval: string) => void;
  setIsLoading: (isLoading: boolean) => void;
  campaignInterval?: string;
}): React.JSX.Element | null {
  const [defaultPayoutInterval, setDefaultPayoutInterval] = useState<string>();
  const onUpdatePayoutFrequency = async (
    payoutInterval: string,
  ): Promise<void> => {
    setFrequencyModalIsOpen(false);
    setIsLoading(true);
    let selectedProviderId;
    if (selectedBankAccountOption?.type === 'payableOrg') {
      selectedProviderId = payableFinancialAccount?.acctId;
    } else if (
      selectedBankAccountOption?.type === 'campaign' ||
      selectedBankAccountOption?.type === 'add'
    ) {
      selectedProviderId = financialAccount?.acctId;
    }
    if (!selectedProviderId) {
      throw new Error('selectedProviderId not set');
    }

    await setStripeConnectAccountPayoutFrequency(
      selectedProviderId,
      payoutInterval,
      stripeEnv,
      financialAccount?.orgId,
    );
    onIntervalUpdate(payoutInterval);
    setIsLoading(false);

    if (financialAccount?.acctId) {
      const accts = await getStripeConnectAccountBankAccounts(
        financialAccount.acctId,
        stripeEnv,
      );
      setBankAccounts(accts);
    }

    if (payableFinancialAccount?.acctId) {
      const accts = await getStripeConnectAccountBankAccounts(
        payableFinancialAccount?.acctId,
        stripeEnv,
      );
      setPayableBankAccounts(accts);
    }
  };

  useEffect(() => {
    if (selectedBankAccountOption?.type === 'payableOrg') {
      setDefaultPayoutInterval(
        payableStripeConnectAccount?.settings.payouts.schedule.interval,
      );
    } else {
      setDefaultPayoutInterval(
        campaignInterval ||
          stripeConnectAccount?.settings.payouts.schedule.interval,
      );
    }
  }, [
    campaignInterval,
    payableStripeConnectAccount?.settings.payouts.schedule.interval,
    selectedBankAccountOption?.type,
    stripeConnectAccount?.settings.payouts.schedule.interval,
  ]);

  if (defaultPayoutInterval) {
    return (
      <ChangePayoutIntervalModal
        isOpen={frequencyModalIsOpen}
        showHeader={false}
        stripeEnv={stripeEnv}
        onUpdate={onUpdatePayoutFrequency}
        onCancel={(): void => setFrequencyModalIsOpen(false)}
        toggle={(): void => setFrequencyModalIsOpen(false)}
        defaultInterval={defaultPayoutInterval}
      />
    );
  }
  return null;
}
